import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { WebapiService } from '../webapi.service';
import { Router,ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-new-application',
  templateUrl: './new-application.component.html',
  styleUrls: ['./new-application.component.scss']
})
export class NewApplicationComponent implements OnInit {
  @ViewChild('appfile') fileInput!: ElementRef;
  formData: any = {};
  startDate: any;
  endDate: any;
  clientList: any;
  clientChecks: any=[];
  checksArr: any = [];
  processList: any;
  loginId: any;
  appData: any;
  appId: any;
  appIdCount: any;
  checksCount: any;
  checkCode:any
  copyAppId: any;
  appPreview: any;
  loginType: any;
  checkList: any=[];
  spocList:any=[];
  constructor(private WebApiService: WebapiService, private router: Router, private activatedRoute:ActivatedRoute) { }

  ngOnInit(): void {

    this.getClient();
    this.getAllCheck();

  this.appId = this.activatedRoute.snapshot.paramMap.get('id');
  this.copyAppId = this.activatedRoute.snapshot.queryParamMap.get('copy');

    if(this.appId) {
      this.getApplicationdetail(this.appId);
    }
    if(this.copyAppId) {
      this.getApplicationdetail(this.copyAppId);
    }

    this.loginId = sessionStorage.getItem('loginId');
    this.loginType = sessionStorage.getItem('type');

    if(this.loginType == 3){
      this.getProcessByClientV2(this.loginId);
      this.formData.clientId = this.loginId;
      this.getAllSpocByClient(this.loginId,'client');
    }
    else if(this.loginType == 1 || this.loginType == 4){
      this.getAllSpocByClient('','admin');
    }
  }

  getAllSpocByClient(client:any,type:any){
    let val = {};
    if(type == 'client'){
      val = {
        clientId:client
      }
    }
    else{
      val = {
        perm:'all'
      }
    }
    this.WebApiService.getAllSpocByClient(val).subscribe((res:any)=>{
      if(res.status == 'success'){
        this.spocList = res.data;
      }
      else{
        this.spocList = [];
      }
      
    })
  }

  // cloneCheck(e:any,feilds:any=[]){
  //   this.checkList.push({
  //     checkName:e,
  //     checkFeilds:feilds
  //   })
    
  // }

  cloneCheck(e: any, fields: any = []) {
    const baseName = e.replace(/\s\d+$/, '');

    // Get all existing checks of the same base name
    const sameTypeChecks = this.checkList.filter((item: any) =>
      item.checkName.startsWith(baseName)
    );
  
    const nextNumber = sameTypeChecks.length + 1;
    const newCheckName = `${baseName} ${nextNumber}`;
  
    // 🔥 Deep clone of fields
    const clonedFields = JSON.parse(JSON.stringify(fields));
  
    const newCheck = {
      checkName: newCheckName,
      checkFeilds: clonedFields
    };
  
    // Insert after the last matching check
    let lastIndex = -1;
    for (let i = this.checkList.length - 1; i >= 0; i--) {
      if (this.checkList[i].checkName.startsWith(baseName)) {
        lastIndex = i;
        break;
      }
    }
  
    if (lastIndex !== -1) {
      this.checkList.splice(lastIndex + 1, 0, newCheck);
    } else {
      this.checkList.push(newCheck);
    }
  }

  removeSubCheck(sub:any){
    this.checkList = this.checkList.filter((ev:any)=> ev.checkName != sub.checkName);
    this.formData.checksData = this.formData.checksData.filter((ev:any)=> ev.checkName != sub.checkName);
  }
  checkChange(e:any){
    if(!e.target.checked){
      this.formData.checksData = this.formData.checksData.filter((ev:any)=> ev.checkName != e.target.value);
    }
    else{
      this.checkList.forEach((ev:any) => {
        if(ev.checkName == e.target.value){
          this.formData.checksData.push({
            checkName:ev.checkName,
            checkFeilds:JSON.parse(JSON.stringify(ev.checkFeilds))
          });
        }
      });
    }

  }

   getApplicationdetail(id:any){
    this.WebApiService.getApplicationById(id).subscribe((res:any)=>{
      if(this.appId){
        this.formData = res?.data;
      }
      if(this.copyAppId){
        this.formData = res?.data;
        this.getProcessByClient(res?.data?.clientId);
        delete this.formData._id;
        delete this.formData.checksData
        delete this.formData.process;
        delete this.formData.appProcess;
        delete this.formData.applicationId;
        delete this.formData.created;
        delete this.formData.generatePdf;
      }
     // if(res.invite && res.invite == "false"){
        //   this.formData.invite = false;
        // }
        // else{
        //   this.formData.invite = true;
        // }
        
      this.getProcessByClientV2(res?.data?.clientId);

    });


  }

  getClient() {
    this.WebApiService.getAllClient().subscribe((res: any) => {
      this.clientList = res.user;
    });
  }
  getProcessByClientV2(id:any){
    this.getAppCount(id);
    setTimeout(()=>{
      let arr = this.clientList.filter(e=> e._id == id);
      this.formData.clientName = arr[0].name
      this.processList = arr[0].processList;
      this.checkCode =arr[0].checkCodePrefix;
      // if(this.appIdCount < 1){
      //   this.formData.applicationId = arr[0].appCodePrefix+'1';
      // }
      // else{
      //   this.formData.applicationId = arr[0].appCodePrefix +`${this.appIdCount + 1}`
      // }
    },1000)
    
  }
  getAppCount(id:any){
    this.WebApiService.getAppCount(id).subscribe((res:any)=>{
       this.appIdCount = res.appCount;
       this.checksCount = res.checksCount
    });
  }
  getProcessByClient(a){
    if(this.copyAppId){
      this.getAppCount(a);
      setTimeout(() => {
        let arr = this.clientList.filter(e=> e._id == a);
        this.formData.clientName = arr[0].name
        this.checkCode =arr[0].checkCodePrefix;
        this.processList = arr[0].processList;
        if(this.appIdCount < 1){
          this.formData.applicationId = arr[0].appCodePrefix+'1';
        }
        else{
          this.formData.applicationId = arr[0].appCodePrefix +`${this.appIdCount + 1}`
        }
      }, 1000);
    }
    else{
      this.getAppCount(a.target.value);
      setTimeout(() => {
        let arr = this.clientList.filter(e=> e._id == a.target.value);
        this.formData.clientName = arr[0].name
        this.processList = arr[0].processList;
        this.checkCode =arr[0].checkCodePrefix;
        if(this.appIdCount < 1){
          this.formData.applicationId = arr[0].appCodePrefix+'1';
        }
        else{
          this.formData.applicationId = arr[0].appCodePrefix +`${this.appIdCount + 1}`
        }
      }, 1000);
    }

  }

  getAllCheck() {
    this.WebApiService.getAllCheck().subscribe((res: any) => {
      this.checkList = res.setting;
      
    });
  }


  getCLientProcessData(e: any) {
    if(e.target.value == 'other'){
      this.formData.checksData = [];
    }
    else{
      this.checksArr = [];
      let id = e.target.value;
      let arr = this.processList.filter(c=> c.process == e.target.value);
      let final = arr[0].checkList.filter(c=> c.selected == true);
      this.formData.checksData = final;
    }

  }

  negativeAlert(e:any){
if(e.target.value < 0){
  alert("Cannot be negative");
  e.target.value ='';
}
  }
  getCLientProcessDataV2(e:any) {
    this.checksArr = [];
    let id = e;
    this.WebApiService.getProcessChecks(id).subscribe((res: any) => {
      this.clientChecks = JSON.parse(res[0].processChecks);
      this.clientChecks.forEach(e => {
        this.WebApiService.getColumnByTableIns({"tableName":e}).subscribe((res: any) => {
          if(res.length > 0) {
            let val = {
              "name":e,
              "arr":res
            }
            this.checksArr.push(val);
          }
        });

      });


    });


  }
  insertApplication(data: any) {
    if(this.appId){
      data._id = this.appId;
    }
    if(!data.invite){
      data.invite = false;
    }
    if(data.invite == true){
      // this.inviteCandidate(data);
    }
    if(!this.appId || this.copyAppId){
      data.isActive = true;
      data.status = "UNAPPROVED";
      for (let i = 0; i < data.checksData.length; i++) {
        data.checksData[i].checkId = this.checkCode + `${this.checksCount + (i == 0 ? 1 : i+1)}`;
        data.checksData[i].status = 'NEW';
      }
    }
    else{
      data.isActive = true;
      data.status = "UNAPPROVED";
    }
 
    data.performBy = this.loginId;
    this.WebApiService.insertApplication(data).subscribe((res: any) => {
      if(res.status == "ok"){
        let added = sessionStorage.getItem('addedId');
        if(this.loginId == '670654c31539eee3796d1872' || added == '670654c31539eee3796d1872'){
          this.trackUser(this.loginId,'upload_single_case');
        }
        alert(res.msg);
        this.router.navigate(['/application']);
      }
      else{
        alert(res.msg);
        this.router.navigate(['/application']);
      }

    });

  }

  trackUser(empId:any,event:any){
    let val = {
      employeeId:empId,
      eventType:event,
      eventDescription:'Upload Single Case in panel'
    }
    this.WebApiService.trackUser(val).subscribe((res:any)=>{
       
    });
  }

  // inviteCandidate(id:any,candName:any,clientName:any,email:any){
  //   let val = {
  //    appId:id,
  //    candName:candName,
  //    clientName:clientName,
  //    url:this.inviteUrl,
  //    candidateEmail:email
  //   }
  //   this.WebApiService.inviteEmail(val).subscribe((res:any)=>{
  //    console.log(res);
  //    if(res.status == "ok"){
  //      alert(res.msg);
  //    }
  //    else{
  //      alert("something went wrong");
  //    }
  //  });
  //  }

  getStartDate(e: any) {
    this.startDate = new Date(e.target.value);
    if(this.startDate && this.endDate){
      let timeDiff = this.startDate.getTime() - this.endDate.getTime();
      let daysDiff = timeDiff / (1000 * 3600 * 24);
        this.formData.tatDays = Math.abs(daysDiff);
    }
    //  console.log(this.startDate);

  }
  getEndData(e: any) {
    this.endDate = new Date(e.target.value);
    if(this.endDate && this.startDate){
      let timeDiff = this.endDate.getTime() - this.startDate.getTime();

      if(timeDiff < 0 ){
        alert("end date should be greater than start date");
        this.formData.tatEnd = "";
        this.formData.tatDays = "";
      }
      else{
        let daysDiff = timeDiff / (1000 * 3600 * 24);
        this.formData.tatDays = Math.abs(daysDiff);
      }

    }

  }

  /**
   * Parses flexible text date input and normalises it to yyyy-MM-dd for model binding.
   * Supports: DD-MM-YYYY, DD/MM/YYYY, YYYY-MM-DD, '12 March 2026', '12 Mar 26' etc.
   */
  parseDateField(field: string, event: any) {
    const raw: string = event.target.value?.trim();
    if (!raw) return;

    const monthNames: { [key: string]: string } = {
      january:'01',february:'02',march:'03',april:'04',may:'05',june:'06',
      july:'07',august:'08',september:'09',october:'10',november:'11',december:'12',
      jan:'01',feb:'02',mar:'03',apr:'04',jun:'06',jul:'07',aug:'08',
      sep:'09',oct:'10',nov:'11',dec:'12'
    };

    let day = '', month = '', year = '';

    // Match "12 March 2026" or "12 Mar 2026"
    const textMatch = raw.match(/^(\d{1,2})\s+([a-zA-Z]+)\s+(\d{2,4})$/);
    if (textMatch) {
      day   = textMatch[1].padStart(2,'0');
      month = monthNames[textMatch[2].toLowerCase()] || '';
      year  = textMatch[3].length === 2 ? '20' + textMatch[3] : textMatch[3];
    }

    // Match DD-MM-YYYY or DD/MM/YYYY
    const numMatch = raw.match(/^(\d{1,2})[-\/](\d{1,2})[-\/](\d{2,4})$/);
    if (!textMatch && numMatch) {
      day   = numMatch[1].padStart(2,'0');
      month = numMatch[2].padStart(2,'0');
      year  = numMatch[3].length === 2 ? '20' + numMatch[3] : numMatch[3];
    }

    // Match YYYY-MM-DD already in correct format
    const isoMatch = raw.match(/^(\d{4})-(\d{2})-(\d{2})$/);
    if (!textMatch && !numMatch && isoMatch) {
      this.formData[field] = raw;
      return;
    }

    if (day && month && year) {
      this.formData[field] = `${year}-${month}-${day}`;
      // Display value is updated via formatDateDisplay bound to ngModel,
      // but we update target value anyway to be safe before change detection runs.
      event.target.value = this.formatDateDisplay(`${year}-${month}-${day}`);
    }
  }

  formatDateDisplay(dateStr: string): string {
    if (!dateStr) return '';
    const isoMatch = dateStr.match(/^(\d{4})-(\d{2})-(\d{2})$/);
    if (isoMatch) {
      const year = isoMatch[1];
      const month = isoMatch[2];
      const day = isoMatch[3];
      const monthNames = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
      return `${day} ${monthNames[parseInt(month, 10) - 1]} ${year}`;
    }
    return dateStr;
  }

  getFile(e:any){
    // this.formData.file = e.target.files[0];
    const formData = new FormData();
    formData.append('image',e.target.files[0]);
    formData.append('type','return');
    if (e.target.files[0]) {
      const reader = new FileReader();
      reader.onload = (e: any) => {
        this.appPreview = e.target.result;
      };
      reader.readAsDataURL(e.target.files[0]);
    }
    this.WebApiService.uploadImage(formData).subscribe((res: any) => {
       if(res.status == "ok"){
         alert('upload success');
         this.formData.appDoc = res.imageName
        }
        else{
         alert("something went wrong")
        }
     });
  }


  getChecksFile(e:any,index:any){
  const formData = new FormData();
  formData.append('image',e.target.files[0]);
  formData.append('type','return');
  if (e.target.files[0]) {
    const reader = new FileReader();
    reader.onload = (e: any) => {
      this.formData.checksData[index].chkPreview = e.target.result;
    };
    reader.readAsDataURL(e.target.files[0]);
  }
  this.WebApiService.uploadImage(formData).subscribe((res: any) => {
     if(res.status == "ok"){
       alert('upload success');
       e.target.value = '';
       this.formData.checksData[index].checkDoc = [res.imageName];
      }
      else{
       alert("something went wrong")
      }
   });
  }

  removeAppPreview(){
    this.appPreview = '';
    this.formData.appDoc = '';
    this.fileInput.nativeElement.value = '';
  }

  removechkPreview(i:any){
    this.formData.checksData[i].chkPreview = ''
    this.formData.checksData[i].checkDoc = [];
  }

}
